<template>

  <div class="recycle_container">
    <div class="detail_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in detailImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="detail_center_one">
      <div class="center_one_title">
        <div class="center_one_title_line"></div>
        <div class="center_one_title_content">智能投放门</div>
        <div class="center_one_title_line"></div>
      </div>

      <div class="center_one_body">
        <img class="oneBodyImgCls" src="../assets/images/tf_center_001.png"/>
      </div>

    </div>

    <div class="detail_center_two">

      <div class="center_two_a">
        <div class="center_two_a_left"></div>
        <div class="center_two_a_right"></div>
      </div>

      <div class="center_two_b">
        <div class="center_two_b_left"></div>
        <div class="center_two_b_center">智能投放门</div>
        <div class="center_two_b_right"></div>
      </div>

      <div class="center_two_c">
        <div class="center_two_c_a">
          智能投放门整体设计简洁美观，颜色清新，质感高端。该设备内置满载检测、称重检测、防夹检测等多种传感器，时刻检测箱体内部情况和控制过程，保障设备正常运行和居民的安全。用户通过刷卡或者二维码扫描或者使用手机app扫描，在触摸屏上的二维码验证身份，选择要回收的物品，按图案标识对应分类投放。设备会自动称重，按回收物重量和类别计算积分转入居民账户。
          <br/>——通过奖励提高居民对垃圾可回收物的分类积极性，大大减轻后续垃圾处理的负担。
          <br/>——减少垃圾后续处理中的环境污染，使可回收垃圾得到有效利用。
          <br/>——有效杜绝有害可回收物对坏境的污染。
          <br/>——企业能通过回收可回收物获得收益。
        </div>
      </div>

      <div class="center_two_d">外观尺寸</div>
      <div class="center_two_e">
        单个投放门：860mm(宽)*1760mm(高)
      </div>
      <div class="center_two_e">
        投口尺寸：400mm(宽)*320mm(高)
      </div>
      <div class="center_two_e">
        终控尺寸：598mm(宽)*1750mm(高)
      </div>

      <div class="center_other_adorn_right">
        <img class="adorn_img" src="../assets/images/home_center_adorn.png">
      </div>


      <div class="center_two_d">应用场景</div>
      <div class="center_two_e">
        居民社区，公共场所，小区宽阔区域
      </div>

      <div class="center_two_d">分类</div>
      <div class="center_two_e">
        可回收物I易腐(厨余)垃圾I其他垃圾I其他垃圾 <span
          style="font-size: 24px;color: #FE0303;font-family: Source Han Sans CN;font-weight: 400;">可定制</span>
      </div>

      <div class="center_two_d">功能</div>
      <div class="center_two_f">
        <img src="../assets/images/tf3661_center_002.png">
      </div>

    </div>

    <div class="detail_center_three">
      <div class="center_three_body_left">
        <div class="three_body_left_left_double">垃圾<br>称重</div>
        <div class="three_body_left_right">对投放的垃圾进行称重。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">扫码<br>开门</div>
        <div class="three_body_right_right" style="text-align: right">居民可以刷卡或扫码，自动打开投放口；也可以触摸开关，进行手动打开投放口。</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left_double">满溢<br>检测</div>
        <div class="three_body_left_right">垃圾体积超过桶最高沿，指示居民垃圾桶已满，并锁住对应投放口，拒绝居民投放。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">满溢<br>指示</div>
        <div class="three_body_right_right" style="text-align: right">通过LED指示垃圾桶内垃圾满溢状态。</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left_double">数据<br>通讯</div>
        <div class="three_body_left_right">通过网络，与后台进行数据同步，如刷卡卡号、垃圾桶满溢状态等工作。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">刷卡<br>取桶</div>
        <div class="three_body_right_right" style="text-align: right">清运人员刷卡自动开门，取桶进行垃圾装运，同时具备钥匙开锁取桶功能。</div>
      </div>

    </div>

    <div class="detail_center_four_copy">
      <img style="width: 70%;margin-top: 32px" src="../assets/images/tf3661_center_003.png"/>
    </div>
    <div class="center_four_text_copy center_four_text">(可定制)</div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      pagesHeight: "",
      detailImgList: [
        {
          url: require("../assets/images/hc3620_top_001.png")
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pagesHeight = this.$refs.pagesRef.clientHeight;
    })
  },
}
</script>

<style lang="less" scoped>

@import "../assets/css/detailCommon";

@media screen and (max-width: 1280px) {

  .center_one_body_current {
    height: 520px;

    .oneBodyImgCls {
      width: 100%;
      height: 520px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .center_one_body_current {
    height: 600px;

    .oneBodyImgCls {
      width: 100%;
      height: 600px;
    }
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .center_one_body_current {
    height: 786px;

    .oneBodyImgCls {
      width: 100%;
      height: 786px;
    }
  }
}

.center_one_body_current {
  display: flex;

  .oneBodyImgCls {
  }
}

.detail_center_four_copy {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}

.center_four_text_copy {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 32px 0;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #4575B5;
}


</style>